import React, { useMemo } from 'react';

import * as Styled from 'events/styles/DaySummary.style';

const SPARKLINE_EMPTY_BARS = 46;

interface SparklineProps {
  resolvedCount: number;
  openCount: number;
}

export default function Sparkline({
  resolvedCount,
  openCount,
}: SparklineProps): JSX.Element {
  const total = resolvedCount + openCount;
  const isEmpty = total === 0;

  const bars = useMemo(() => {
    if (isEmpty) {
      return Array.from(
        { length: SPARKLINE_EMPTY_BARS },
        () => Styled.EMPTY_COLOUR
      );
    }
    return Array.from({ length: total }, (_, i) =>
      i < resolvedCount ? Styled.RESOLVED_COLOUR : Styled.OPEN_COLOUR
    );
  }, [isEmpty, total, resolvedCount]);

  return (
    <Styled.Sparkline aria-hidden>
      {bars.map((colour, i) => {
        const roundEnds = bars.length <= 30;
        return (
          <Styled.SparklineBar
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            $colour={colour}
            $isFirst={roundEnds && i === 0}
            $isLast={roundEnds && i === bars.length - 1}
          />
        );
      })}
    </Styled.Sparkline>
  );
}
